import React from "react";
import { useTranslation } from "react-i18next";
import Card from "../generic/Card";

function WhatIsTaoluSection() {
  const { t } = useTranslation();

  const cards = [
    {
      id: "card1",
      icon: "fas fa-list-ol",
      title: t("taolu_what_is.card1.title"),
      description: t("taolu_what_is.card1.description"),
    },
    {
      id: "card2",
      icon: "fas fa-bullseye",
      title: t("taolu_what_is.card2.title"),
      description: t("taolu_what_is.card2.description"),
    },
    {
      id: "card3",
      icon: "fas fa-yin-yang",
      title: t("taolu_what_is.card3.title"),
      description: t("taolu_what_is.card3.description"),
    },
  ];

  return (
    <section
      className="relative z-10 bg-white pb-14 pt-24 transition-colors dark:bg-slate-800 md:pb-16"
      id="what-is-taolu-section"
      aria-labelledby="what-is-taolu-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <header className="mb-10 text-center md:mb-12">
          <h2
            id="what-is-taolu-heading"
            className="relative mb-5 inline-block text-4xl font-semibold tracking-tight text-primary dark:text-primary-light md:text-5xl"
          >
            {t("taolu_what_is.title")}
            <span
              className="absolute -bottom-2.5 left-1/2 h-0.5 w-16 -translate-x-1/2 rounded-full bg-primary dark:bg-primary-light"
              aria-hidden
            />
          </h2>
        </header>

        <ul className="m-0 grid list-none grid-cols-1 gap-5 p-0 md:grid-cols-3 md:gap-6">
          {cards.map((item) => (
            <li key={item.id} className="min-h-0">
              <Card
                icon={item.icon}
                title={item.title}
                description={item.description}
              />
            </li>
          ))}
        </ul>

        <div className="mx-auto mt-10 max-w-4xl md:mt-12">
          <p className="whitespace-pre-line text-pretty text-lg leading-relaxed text-slate-600 dark:text-slate-400">
            {t("taolu_what_is.text")}
          </p>
        </div>
      </div>
    </section>
  );
}

export default WhatIsTaoluSection;
